import Grid from '@mui/material/Grid2'
import { map } from 'lodash'
import { FC } from 'react'
import { TariffDTO } from '../../../../swagger/dto'
import { PackageCard } from './PackageCard'
import {useMediaQuery} from "@mui/material";
import {theme} from "../../../../theme";

type Props = {
    tariffList: TariffDTO[]
}

export const PackagesList: FC<Props> = ({ tariffList }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    return (
        <Grid mt={3} container spacing={isMobile ? 1 :0} sx={{ width: '100%', display: 'flex' }} color="primary">
            {map(tariffList, (tariffByTitle, index) => {
                return <PackageCard tariff={tariffByTitle} index={index} />
            })}
        </Grid>
    )
}
